(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palim-numbered-index"] && !Shopify.designMode) return;
  try {
    
  class PalimIndex {
    /** @param {HTMLElement} root */
    constructor(root) {
      this.root = root;
      this.rows = [...root.querySelectorAll('.palim-index__row')];
      this.figures = [...root.querySelectorAll('.palim-index__figure')];
      for (const row of this.rows) {
        row.addEventListener('mouseenter', () => this.activate(row.dataset.index));
        row.addEventListener('focus', () => this.activate(row.dataset.index));
      }
    }

    /** @param {string} index */
    activate(index) {
      for (const figure of this.figures) {
        figure.classList.toggle('is-active', figure.dataset.index === index);
      }
      for (const row of this.rows) {
        if (row.dataset.index === index) {
          row.setAttribute('aria-current', 'true');
        } else {
          row.removeAttribute('aria-current');
        }
      }
    }
  }

  const initPalimIndex = (scope = document) => {
    for (const root of scope.querySelectorAll('[data-palim-index]')) {
      if (root.dataset.ready) continue;
      root.dataset.ready = 'true';
      new PalimIndex(root);
    }
  };

  initPalimIndex();
  document.addEventListener('shopify:section:load', (event) => initPalimIndex(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palim-reels"] && !Shopify.designMode) return;
  try {
    
  class PalimReels extends HTMLElement {
    connectedCallback() {
      this.videos = [...this.querySelectorAll('video')];
      if (!this.videos.length) return;
      for (const video of this.videos) {
        video.muted = true;
        video.removeAttribute('controls');
      }

      // Tap pauses or resumes a reel (the pause control motion guidelines ask for); a paused reel stays paused.
      for (const video of this.videos) {
        video.addEventListener('click', () => {
          video.dataset.userPaused = String(!video.paused);
          if (video.paused) video.play().catch(() => {});
          else video.pause();
        });
      }

      // Play while on screen, pause when scrolled away.
      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          const video = entry.target;
          if (entry.isIntersecting && video.dataset.userPaused !== 'true') {
            video.play().catch(() => {});
          } else if (!entry.isIntersecting) {
            video.pause();
          }
        }
      }, { threshold: 0.6 });
      for (const video of this.videos) this.observer.observe(video);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('palim-reels')) customElements.define('palim-reels', PalimReels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palim-routine-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* answers -> outcome. q1 roots (a oily/flat, b coated with product, c fine), q2 lengths (a dry/tangly,
       b damaged by colour or heat, c fine), q3 washing (a most days, b 2-3 times a week, c once a week or less) */
    const pick = (r, l, w) => {
      if (r === 'a') return l === 'a' ? 'pair' : l === 'b' ? 'p01_06' : 'p01';
      if (r === 'b') {
        if (l === 'b') return 'weekly';
        if (w === 'c') return l === 'a' ? 'p08_05' : 'p08';
        return l === 'a' ? 'p02_05' : 'p02';
      }
      if (l === 'a') return w === 'a' ? 'washday' : 'p05';
      if (l === 'b') return 'prewash';
      return 'washday';
    };
    const HAS01 = ['pair', 'p01', 'p01_06'];
    /* which tips fit the answers: q4 hair (a fine, b medium, c thick or curly), q5 extras */
    const tipsFor = (a) => {
      const t = [];
      if (a.extras.includes('dark') && HAS01.includes(a.key)) t.push('dark');
      /* 02 and 08 are both scalp resets: whenever one is suggested, say how they differ (blueprint 2026-09-28) */
      if (['p02', 'p02_05', 'p08', 'p08_05', 'weekly'].includes(a.key)) t.push('scalp');
      if (a.q1 === 'b') t.push('buildup');
      if (a.q1 === 'a' && a.q2 === 'a') t.push('combo');
      if (a.q4 === 'a') t.push('fine');
      if (a.q4 === 'c') t.push('thick');
      if (a.extras.includes('colour')) t.push('colour');
      if (a.extras.includes('gym')) t.push('gym');
      if (a.extras.includes('travel')) t.push('travel');
      if (a.extras.includes('sensitive')) t.push('sensitive');
      if (a.q3 === 'a' && !t.includes('combo')) t.push('daily');
      return t.slice(0, 4);
    };
    const STORE = 'palim-finder';
    /* the last result is kept on this device, so the email's "See my routine" link and a return visit can offer it */
    const save = (a) => { try { localStorage.setItem(STORE, JSON.stringify(a)); } catch (e) {} };
    const load = () => { try { return JSON.parse(localStorage.getItem(STORE) || 'null'); } catch (e) { return null; } };
    const encode = (a) => `routine=${a.q1}${a.q2}${a.q3}${a.q4 || '-'}${a.extras.length ? '.' + a.extras.join('.') : ''}`;
    const decode = (hash) => {
      const m = /routine=([abc])([abc])([abc])([abc-])((?:\.[a-z]+)*)/.exec(hash || '');
      if (!m) return null;
      const a = { q1: m[1], q2: m[2], q3: m[3], q4: m[4] === '-' ? '' : m[4], extras: m[5] ? m[5].slice(1).split('.') : [] };
      a.key = pick(a.q1, a.q2, a.q3);
      return a;
    };

    const init = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      const copy = JSON.parse(root.querySelector('[data-finder-copy-json]').textContent);
      const form = root.querySelector('[data-palim-finder-form]');
      const steps = [...form.querySelectorAll('.palim-finder__q')];
      const back = form.querySelector('[data-finder-back]');
      const submit = form.querySelector('[data-finder-submit]');
      const hint = form.querySelector('[data-finder-hint]');
      const label = form.querySelector('[data-step-label]');
      const results = [...root.querySelectorAll('[data-outcome]')];
      const told = root.querySelector('[data-finder-told]');
      const tips = root.querySelector('[data-finder-tips]');
      const email = root.querySelector('[data-finder-email]');
      const emailForm = root.querySelector('[data-finder-email-form]');
      const after = root.querySelector('[data-finder-after]');
      let current = 0;

      const go = (i) => {
        current = Math.max(0, Math.min(steps.length - 1, i));
        steps.forEach((s, n) => s.classList.toggle('is-current', n === current));
        root.style.setProperty('--palim-finder-progress', ((current + 1) / steps.length).toFixed(3));
        label.textContent = copy.step.replace('[n]', current + 1).replace('[total]', steps.length);
        root.querySelectorAll('[data-step-img]').forEach((img) => img.classList.toggle('is-active', Number(img.dataset.stepImg) === current + 1));
        back.hidden = current === 0;
        submit.hidden = current !== steps.length - 1;
        hint.hidden = true;
      };
      const answers = () => {
        const d = new FormData(form);
        const a = { q1: d.get('q1'), q2: d.get('q2'), q3: d.get('q3'), q4: d.get('q4') || '', extras: d.getAll('q5') };
        a.key = a.q1 && a.q2 && a.q3 ? pick(a.q1, a.q2, a.q3) : null;
        return a;
      };
      const idx = (v) => ({ a: 0, b: 1, c: 2 })[v];
      const show = (a, scroll) => {
        for (const r of results) r.hidden = r.dataset.outcome !== a.key;
        const sentence = copy.told.replace('[roots]', copy.q1[idx(a.q1)]).replace('[ends]', copy.q2[idx(a.q2)]).replace('[wash]', copy.q3[idx(a.q3)]);
        told.textContent = sentence;
        told.hidden = false;
        const wanted = tipsFor(a);
        let any = false;
        for (const li of tips.querySelectorAll('[data-tip]')) { const on = wanted.includes(li.dataset.tip); li.hidden = !on; any = any || on; }
        tips.hidden = !any;
        email.hidden = false;
        after.hidden = false;
        form.hidden = true;
        root.classList.add('has-result');
        const tagInput = root.querySelector('[data-finder-tags]');
        if (tagInput) tagInput.value = `newsletter,routine-finder,routine-${a.key}`;
        save(a);
        try { history.replaceState(null, '', `${location.pathname}${location.search.replace(/[?&]customer_posted=true/, '')}#${encode(a)}`); } catch (e) {}
        if (scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const shown = results.find((r) => !r.hidden);
        shown?.querySelector('h3')?.setAttribute('tabindex', '-1');
        if (scroll) shown?.querySelector('h3')?.focus({ preventScroll: true });
      };

      form.addEventListener('change', (event) => {
        const field = event.target.closest('.palim-finder__q');
        if (!field || event.target.type !== 'radio') return;
        const i = steps.indexOf(field);
        if (i < steps.length - 1) setTimeout(() => go(i + 1), 260);
      });
      back.addEventListener('click', () => go(current - 1));
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const a = answers();
        if (!a.key) {
          hint.hidden = false;
          go(!a.q1 ? 0 : !a.q2 ? 1 : 2);
          return;
        }
        show(a, true);
      });
      root.addEventListener('click', async (event) => {
        if (event.target.closest('[data-palim-finder-reset]')) {
          for (const r of results) r.hidden = true;
          told.hidden = true; tips.hidden = true; email.hidden = true; after.hidden = true;
          root.classList.remove('has-result');
          form.reset(); form.hidden = false; go(0);
          try { localStorage.removeItem(STORE); history.replaceState(null, '', location.pathname); } catch (e) {}
          form.querySelector('input')?.focus();
          return;
        }
        const copyBtn = event.target.closest('[data-finder-copy]');
        if (copyBtn) { try { await navigator.clipboard.writeText(copyBtn.dataset.finderCopy); copyBtn.textContent = copy.copied; } catch (e) {} return; }
        const share = event.target.closest('[data-finder-share]');
        if (share) { try { await navigator.clipboard.writeText(location.href); share.textContent = copy.linkCopied; } catch (e) {} }
      });
      emailForm?.addEventListener('submit', () => { const a = answers(); if (a.key) save(a); });

      go(0);
      /* coming back: a shared link (#routine=...), or the page the email form reloads */
      const done = root.querySelector('[data-finder-email-done]');
      const fromLink = decode(location.hash);
      const returning = done && done.dataset.posted === 'true' ? load() : null;
      const restore = fromLink || returning;
      if (restore && restore.key) {
        for (const [q, v] of [['q1', restore.q1], ['q2', restore.q2], ['q3', restore.q3], ['q4', restore.q4]]) { const i = v && form.querySelector(`input[name=${q}][value=${v}]`); if (i) i.checked = true; }
        for (const x of restore.extras || []) { const i = form.querySelector(`input[name=q5][value=${x}]`); if (i) i.checked = true; }
        show(restore, false);
        if (returning) email.scrollIntoView({ block: 'center' });
      } else {
        const last = load();
        const resume = root.querySelector('[data-finder-resume]');
        if (last && last.key && resume) {
          resume.hidden = false;
          resume.addEventListener('click', () => {
            for (const [q, v] of [['q1', last.q1], ['q2', last.q2], ['q3', last.q3], ['q4', last.q4]]) { const i = v && form.querySelector(`input[name=${q}][value=${v}]`); if (i) i.checked = true; }
            for (const x of last.extras || []) { const i = form.querySelector(`input[name=q5][value=${x}]`); if (i) i.checked = true; }
            show(last, true);
          });
        }
      }
    };

    const start = () => document.querySelectorAll('[data-palim-finder]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palim-signature"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.palimRail) return;
    window.palimRail = true;
    const init = () => {
      const rail = document.querySelector('[data-palim-rail]');
      if (!rail) return;
      const draw = rail.querySelector('.palim-strand-rail__draw');
      const drop = rail.querySelector('.palim-strand-rail__drop');
      const halo = rail.querySelector('.palim-strand-rail__halo');
      const zones = [...rail.querySelectorAll('.palim-strand-rail__zone')].map((li) => ({
        li,
        el: li.dataset.target === 'top' ? document.body : document.querySelector(`[id$="__${li.dataset.target}"]`),
      })).filter((z) => z.el);
      const total = draw.getTotalLength();
      draw.style.strokeDasharray = `${total} ${total}`;
      // labels sit evenly down the strand; the scroll is mapped piece by piece so the droplet reaches each label
      // exactly as its section reaches the top of the screen, and runs on to the tip after the last one
      const layout = () => {
        const doc = document.documentElement.scrollHeight - window.innerHeight;
        const n = zones.length;
        zones.forEach((z, i) => {
          const y = z.el === document.body ? 0 : z.el.getBoundingClientRect().top + window.scrollY;
          z.scroll = Math.min(doc, Math.max(0, y));
          z.at = n > 1 ? i / n : 0;
          z.li.style.setProperty('--palim-zone-y', `${(z.at * 100).toFixed(2)}%`);
        });
        stops = zones.map((z) => [z.scroll, z.at]).concat([[doc, 1]]);
        update();
      };
      let stops = [[0, 0], [1, 1]];
      const railAt = (y) => {
        for (let i = 0; i < stops.length - 1; i++) {
          const [s0, a0] = stops[i], [s1, a1] = stops[i + 1];
          if (y <= s1) return a0 + (a1 - a0) * Math.min(1, Math.max(0, (y - s0) / ((s1 - s0) || 1)));
        }
        return 1;
      };
      const update = () => {
        const p = railAt(window.scrollY);
        draw.style.strokeDashoffset = (total * (1 - p)).toFixed(2);
        const pt = draw.getPointAtLength(total * p);
        for (const c of [drop, halo]) { c.setAttribute('cx', pt.x.toFixed(2)); c.setAttribute('cy', pt.y.toFixed(2)); }
        let active = 0;
        zones.forEach((z, i) => { if (window.scrollY + window.innerHeight * 0.4 >= z.scroll) active = i; });
        zones.forEach((z, i) => {
          z.li.classList.toggle('is-active', i === active);
          z.li.classList.toggle('is-passed', i < active);
        });
      };
      for (const z of zones) {
        if (z.el !== document.body && z.el.id) z.li.querySelector('a').setAttribute('href', `#${z.el.id}`);
        z.li.querySelector('a').addEventListener('click', (e) => {
          e.preventDefault();
          const top = z.el === document.body ? 0 : z.el.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top, behavior: 'smooth' });
        });
      }
      let ticking = false;
      const guide = document.querySelector('[data-palim-guide]');
      const guideUpdate = () => {
        if (!guide) return;
        const end = document.documentElement.scrollHeight - window.innerHeight * 2.2;
        guide.classList.toggle('is-shown', window.scrollY > window.innerHeight * 0.8 && window.scrollY < end);
      };
      window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(() => { ticking = false; update(); guideUpdate(); }); } }, { passive: true });
      window.addEventListener('resize', layout);
      window.addEventListener('load', layout);
      layout();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palim-strand"] && !Shopify.designMode) return;
  try {
    
  class PalimStrand extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.select('root', false);

      for (const tab of this.tabs) {
        tab.addEventListener('click', () => this.select(tab.dataset.target, true));
        tab.addEventListener('keydown', (event) => this.#onKeydown(event));
      }
      for (const zone of this.querySelectorAll('.palim-strand__zone')) {
        zone.addEventListener('click', () => this.select(zone.dataset.target, false));
      }

      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.classList.add('is-drawn');
          this.observer.disconnect();
        }
      }, { threshold: 0.35 });
      this.observer.observe(this);

      this.#setUpPhoto();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }
      cancelAnimationFrame(this.frame);
    }

    /** Photo version: reveal the hair from root to tip with the scroll, light up the age marks, tap to pick a zone. */
    #setUpPhoto() {
      this.photo = this.querySelector('.palim-strand__photo');
      if (!this.photo) return;
      this.marks = [...this.photo.querySelectorAll('.palim-strand__mark')];

      // Tapping the upper-right part of the hair picks ROOT, the lower-left part LENGTHS.
      this.photo.addEventListener('click', (event) => {
        const rect = this.photo.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width;
        const y = (event.clientY - rect.top) / rect.height;
        const along = this.photo.dataset.direction === 'diagonal' ? (1 - x + y) / 2 : y;
        this.select(along < 0.5 ? 'root' : 'lengths', false);
      });

      this.classList.add('is-growing');
      this.onScroll = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.#grow());
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.#grow();
    }

    #grow() {
      const rect = this.photo.getBoundingClientRect();
      const viewport = window.innerHeight;
      const progress = Math.min(1, Math.max(0, (viewport * 0.9 - rect.top) / (rect.height * 0.9)));
      this.photo.style.setProperty('--palim-strand-p', progress.toFixed(3));
      for (const mark of this.marks) {
        mark.classList.toggle('is-on', progress >= Number(mark.dataset.at));
      }
      this.classList.toggle('is-grown', progress >= 1);
    }

    /**
     * @param {string} target - 'root' or 'lengths'
     * @param {boolean} moveFocus
     */
    select(target, moveFocus) {
      this.dataset.state = target;
      for (const tab of this.tabs) {
        const active = tab.dataset.target === target;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && moveFocus) tab.focus();
      }
      for (const panel of this.panels) {
        panel.hidden = panel.dataset.panel !== target;
      }
    }

    /** @param {KeyboardEvent} event */
    #onKeydown(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const current = this.dataset.state;
      const next = current === 'root' ? 'lengths' : 'root';
      if (event.key === 'Home') return this.select('root', true);
      if (event.key === 'End') return this.select('lengths', true);
      this.select(next, true);
    }
  }

  if (!customElements.get('palim-strand')) customElements.define('palim-strand', PalimStrand);

  } catch(e) { console.error(e); }
})();
})();
